import React from "react"
import Thumbnail from "./Thumbnail"
import customProtocolCheck from "custom-protocol-check"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlay, faCog, faThumbsUp, faDownload } from "@fortawesome/free-solid-svg-icons"

import { Link } from "react-router-dom"

class GameTitle extends React.Component {
    constructor() {
        super()
        this.textArea = React.createRef()
        this.state = {
            rating: null,
            isCollaborator: false,
        }
    }
    downloadInstaller = (e) => {
        window.open(`https://arcade-launcher-installer.s3-us-west-1.amazonaws.com/installer_release.exe`, "_self")
    }
    onClickPlay = (e) => {
        window.open(`https://play.funovus.com/${this.props.data.id}`, "_blank")
    }
    componentDidMount(){
        fetch(`/api/store/project/${this.props.data.id}/rating`)
        .then(res => res.json())
        .then(data => this.setState({rating: data.result}))
        fetch(`/api/data/project/${this.props.data.id}/collaborators`)
        .then(res => res.json())
        .then(data => {
            const emails = data.result.map(email => email.email);
            if (emails.includes(this.props.user.email)) {
                this.setState({
                    isCollaborator: true
                })
            }
        })
        .catch(data => this.setState({error: `Server: ${data.error}`, isLoading: false}))
    }
    getLabel = (isPrivate, isPublic, isOpenSource) => {
        if (isOpenSource) return 'open source';
        if (isPrivate) {
            return 'private';
        } else {
            return 'public';
        }
    }
    render() {
        const { name, id, author, source, openSource, version } = this.props.data
        const label = this.getLabel(this.props.data.private, this.props.data.public, openSource);
        const { isAdmin } = this.props
        return (
            <>
                <div className="basicInfo">
                    <Thumbnail gameName={name} imgUrl={`/api/store/project/${id}/image`} />
                    <div className="gameTitle">
                        <div className="wrapper">
                            <h1 className="gameName">{name}</h1>
                            <h3 className="likeNumber">
                                <FontAwesomeIcon icon={faThumbsUp} /> {this.state.rating}
                            </h3>
                            <h4>Type: {label}</h4>
                            <h3 className="gameAuthor">By <span className="authorName">{author}</span></h3>
                            <h3>
                            
                            </h3>
                            <div className="playInviteGroup">
                                <button className="playBtn" onClick={this.onClickPlay}>
                                    <FontAwesomeIcon icon={faPlay} /> &nbsp; Play
                                </button>
                                {( isAdmin || this.state.isCollaborator )
                                    ? <Link to={`/manage/game/${id}/invite`} >
                                        <button className="manageBtn">
                                            <FontAwesomeIcon icon={faCog} /> &nbsp; Manage
                                        </button>
                                    </Link>
                                : null}
                                {
                                    source ? (
                                        ( isAdmin || openSource ) ? (
                                            <a href={`/api/store/project/${this.props.data.version.projectId}/source`} download={`${name}-${version?.code}.zip`} target="_self">
                                                <button className="manageBtn">
                                                    <FontAwesomeIcon icon={faDownload} /> &nbsp; Source
                                                </button>
                                            </a>
                                        ) : null
                                    ) : null
                                }  
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default GameTitle